import {
  COLLABORATORS_MANAGEMENT_ROUTE,
  HOME_ROUTE,
  PLAN_ROUTE,
  INTEGRATIONS_ROUTE,
  COLLABORATORS_HOME_ROUTE,
  NEW_CHANGE_ORGANIZATION_ROUTE,
  ACCOUNT_ROUTE,
  STORIES_ROUTE,
  NEW_STORY_ROUTE,
  LOAD_BALANCE_ROUTE,
  REWARDS_POINTS_ROUTE,
  REWARDS_POINTS_CONFIG_ROUTE,
  REWARDS_HISTORY_DETAILS_ROUTE,
  REWARDS_HISTORY_ROUTE,
  METRICS_NE_ROUTE,
  REWARDS_POINTS_FILE_ROUTE,
  CHALLENGES_MAIN_ROUTE,
  CREATE_CHALLENGE_ROUTE,
  MANAGE_COLLABORATORS_ROUTE,
  COLLABORATOR_DETAIL_ROUTE,
  BENEFIT_DETAIL_ROUTE,
  INSURANCE_DETAIL_ROUTE,
  BENEFITS_TO_CHOOSE_ROUTE,
  BALANCE_CHARGE_ROUTE,
  REPORTS_ROUTE,
  LANDING_HEALTH_REPORT_ROUTE,
  REQUEST_TABLE_ROUTE,
  REQUEST_DETAIL_ROUTE
} from './auth';
import { WALLET_PORTAL_URL } from './constants';

export const PERMISSIONS = {
  MENU: 'menu',
  MENU_ROOT: {
    BENEFITS: 'menu.benefits',
    COLLABORATORS: 'menu.collaborators',
    HOME: 'menu.home',
    METRICS: 'menu.metrics',
    METRICS_NE: 'menu.metrics-ne',
    SOCIAL_CAUSES: 'menu.metrics-ne.social-causes',
    PLAN: 'menu.plan',
    COMMUNICATIONS: 'menu.communications',
    STORIES_ROOT: {
      LIST: 'menu.stories.list',
      NEW: 'menu.stories.new'
    },
    COLLABORATORS_ROOT: {
      DETAIL: 'menu.collaborators.collaborators-detail',
      MANAGE: 'menu.collaborators.manage-collaborators',
      CANCELED: 'menu.collaborators.canceled-subscriptions',
      REQUEST_PANEL: 'menu.collaborators.request-panel'
    },
    SETTINGS_ROOT: {
      ORGANIZATION: 'menu.settings.organization',
      PLAN: 'menu.settings.plan',
      PROFILE: 'menu.settings.profile',
      INTEGRATIONS: 'menu.settings.integrations'
    },
    CHALLENGES_ROOT: {
      MAIN: 'menu.challenges.main',
      CREATE: 'menu.challenges.create'
    },
    REPORTS_ROOT: {
      MAIN: 'menu.reports.main'
    },
    REQUESTS_ROOT: {
      TABLE: 'menu.requests.table',
      DETAIL: 'menu.requests.detail'
    }
  },
  SUPPORT_FORM: 'support-form',
  MARKETPLACE: 'marketplace',
  REWARDS: 'rewards',
  REWARDS_ROOT: {
    LOAD_BALANCE: 'rewards.load-balance',
    POINTS: 'rewards.points',
    HISTORY: 'rewards.history'
  }
};

export const DEFAULT_PERMISSIONS = [PERMISSIONS['MENU_ROOT']['METRICS'], PERMISSIONS['SUPPORT_FORM']];

export const PERMISSIONS_BY_ROUTE: { [route: string]: string[] } = {
  [HOME_ROUTE]: [PERMISSIONS['MENU_ROOT']['HOME']],
  [METRICS_NE_ROUTE]: [PERMISSIONS['MENU_ROOT']['METRICS_NE']],
  [COLLABORATORS_HOME_ROUTE]: [PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['DETAIL']],
  [COLLABORATOR_DETAIL_ROUTE]: [PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['DETAIL']],
  [MANAGE_COLLABORATORS_ROUTE]: [PERMISSIONS['MENU_ROOT']['COLLABORATORS_ROOT']['MANAGE']],
  [PLAN_ROUTE]: [PERMISSIONS['MENU_ROOT']['PLAN']],
  [STORIES_ROUTE]: [PERMISSIONS['MENU_ROOT']['STORIES_ROOT']['LIST']],
  [NEW_STORY_ROUTE]: [PERMISSIONS['MENU_ROOT']['STORIES_ROOT']['NEW']],
  [CHALLENGES_MAIN_ROUTE]: [PERMISSIONS['MENU_ROOT']['CHALLENGES_ROOT']['MAIN']],
  [CREATE_CHALLENGE_ROUTE]: [PERMISSIONS['MENU_ROOT']['CHALLENGES_ROOT']['CREATE']],
  [INTEGRATIONS_ROUTE]: [],
  [NEW_CHANGE_ORGANIZATION_ROUTE]: [],
  [ACCOUNT_ROUTE]: [],
  [WALLET_PORTAL_URL]: [],
  [LOAD_BALANCE_ROUTE]: [PERMISSIONS['REWARDS_ROOT']['LOAD_BALANCE']],
  [REWARDS_POINTS_ROUTE]: [PERMISSIONS['REWARDS_ROOT']['POINTS']],
  [REWARDS_POINTS_CONFIG_ROUTE]: [PERMISSIONS['REWARDS_ROOT']['POINTS']],
  [REWARDS_POINTS_FILE_ROUTE]: [PERMISSIONS['REWARDS_ROOT']['POINTS']],
  [REWARDS_HISTORY_DETAILS_ROUTE]: [PERMISSIONS['REWARDS_ROOT']['HISTORY']],
  [REWARDS_HISTORY_ROUTE]: [PERMISSIONS['REWARDS_ROOT']['HISTORY']],
  [BENEFIT_DETAIL_ROUTE]: [PERMISSIONS['MENU_ROOT']['PLAN']],
  [INSURANCE_DETAIL_ROUTE]: [PERMISSIONS['MENU_ROOT']['PLAN']],
  [BENEFITS_TO_CHOOSE_ROUTE]: [PERMISSIONS['MENU_ROOT']['PLAN']],
  [BALANCE_CHARGE_ROUTE]: [PERMISSIONS['MENU_ROOT']['HOME']],
  [REPORTS_ROUTE]: [PERMISSIONS['MENU_ROOT']['REPORTS_ROOT']['MAIN']],
  [LANDING_HEALTH_REPORT_ROUTE]: [],
  [REPORTS_ROUTE]: [PERMISSIONS['MENU_ROOT']['HOME']],
  [REQUEST_TABLE_ROUTE]: [PERMISSIONS['MENU_ROOT']['REQUESTS_ROOT']['TABLE']],
  [REQUEST_DETAIL_ROUTE]: [PERMISSIONS['MENU_ROOT']['REQUESTS_ROOT']['DETAIL']]
};

export const DEFAULT_ROUTE_BY_ROLE: { [role: string]: string } = {
  default: HOME_ROUTE,
  affinity: HOME_ROUTE,
  'first-payroll': COLLABORATORS_MANAGEMENT_ROUTE
};
